import React from "react";
import CopyScriptPopover from "./CopyScriptPopover";
import ShareScriptPopover from "./ShareScriptPopover";
import { videoButtonLabel } from "../../utils/videos";

const CloseIcon = () => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const PencilIcon = () => (
  <svg
    className="w-4 h-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    />
  </svg>
);

const ScriptOutputHeader = ({
  script,
  showClose,
  onClose,
  onEdit,
  onOpenVideos,
  videosActive = false,
  videoCount = 0,
}) => {
  const title = script?.idea_title || "Script";
  const videoLabel = videoButtonLabel(videoCount);

  return (
    <header className="pb-1 flex-shrink-0">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0 flex-1">
          <h1 className="text-2xl sm:text-[1.625rem] font-semibold text-theme-text truncate pr-2 leading-tight">
            {title}
          </h1>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0 flex-wrap justify-end">
          <CopyScriptPopover script={script} />
          <button
            type="button"
            onClick={onEdit}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded border border-theme-secondary text-theme-text text-sm hover:bg-theme-secondary focus:outline-none focus:ring-2 focus:ring-theme-primary"
            aria-label="Edit script"
          >
            <PencilIcon />
            <span>Edit</span>
          </button>
          <ShareScriptPopover />
          {onOpenVideos ? (
            <button
              type="button"
              onClick={onOpenVideos}
              className={`inline-flex items-center gap-1.5 px-3 py-2 rounded text-sm font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-theme-primary ${
                videosActive
                  ? "bg-theme-primary text-theme-button border border-theme-primary"
                  : "bg-theme-primary text-theme-button border border-transparent"
              }`}
            >
              <span>{videoLabel}</span>
            </button>
          ) : null}
          {showClose ? (
            <button
              type="button"
              onClick={onClose}
              className="p-2 rounded text-theme-text opacity-70 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-theme-primary"
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
};

export default ScriptOutputHeader;
